<script>
export default {
  name: 'BookingLoader',
}
</script>

<template>
  <v-container
    fluid
    class="booking-loader d-flex align-center justify-center fill-height"
  >
    <v-progress-circular
      indeterminate
      color="primary"
      :size="150"
      :width="11"
    ></v-progress-circular>
  </v-container>
</template>

<style lang="scss" scoped>
@import '@styles';

.booking-loader {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media (max-width: 1199px) {
  .v-progress-circular {
    width: 100px !important;
    height: 100px !important;
  }
}

@media (max-width: 769px) {
  .v-progress-circular {
    width: 70px !important;
    height: 70px !important;
  }
}
</style>
